import { post } from "shared/lib/api"
import * as $ from "jquery"

export default function onReCAPTCHASuccess(
  url,
  sitekey,
  formClass,
  buttonClass,
  formRef = null
) {
  jQuery(buttonClass).on("click", e => {
    e.preventDefault()

    if (jQuery(formClass)[0].checkValidity()) {
      grecaptcha.execute()
    } else {
      jQuery(formClass)[0].reportValidity()
    }
  })

  return function (token) {
    post(url, { token }).then(status => {
      if (status.success) {
        jQuery(buttonClass).prop("disabled", true)

        if (formRef) {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          )
        } else {
          jQuery(formClass).submit()
        }
        setTimeout(() => {
          // subscription 3d payment could be declined, then retried with no page reload
          grecaptcha.reset()
        }, 500)
      } else {
        grecaptcha.render(jQuery(".g-recaptcha")[0], {
          sitekey,
          callback: "onReCAPTCHASuccess",
        })
      }
    })
  }
}
